import { stores } from 'state/stores';
import { sendEvent } from './events';
import { clearWebLanguage } from 'translations/t';

export const clearAllUserData = () => {
  stores.lifecycle.isBootstrapped = false;
  stores.account.clearData();
  stores.routines.clearData();
  stores.subscription.clearData();
  stores.routineFolders.clearData();
  stores.userPreferences.clearData();
  stores.exerciseTemplates.clearData();
  stores.exerciseTemplateUnits.clearData();
  stores.betaFeatures.clearData();
  stores.auth.logout();
  clearWebLanguage();
};

export const logout = ({ isUserInitiated }: { isUserInitiated: boolean }) => {
  sendEvent('logout', { isUserInitiated });

  if (isUserInitiated) {
    stores.auth.userLogout();
  }

  clearAllUserData();
  window.location.pathname = '/login';
};
